var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"motd",class:{closed: _vm.closed}},[_c('w-link',{staticClass:"close-button",on:{"click":function($event){return _vm.close()}}},[_c('w-fa',{attrs:{"icon":"times"}})],1),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }